<template>
  <div class="mx-2 my-2">
    <div class="head-content pb-2"><span>Thông báo</span></div>
    <div class="body-notice" id="style-2">
      <div v-if="tasksToday && tasksToday.length">
        <NoticeByDate
          :title="'Hôm nay'"
          :listNoticeTask="tasksToday"
          formatDateTime="HH:mm"
          @redirectListTask="redirectListTask($event)"
        />
      </div>
      <div v-if="tasksYesterday && tasksYesterday.length">
        <NoticeByDate
          :title="'Hôm qua'"
          :listNoticeTask="tasksYesterday"
          formatDateTime="HH:mm"
          @redirectListTask="redirectListTask($event)"
        />
      </div>
      <div v-if="tasksOther && tasksOther.length">
        <NoticeByDate
          :title="'Khác'"
          :listNoticeTask="tasksOther"
          @redirectListTask="redirectListTask($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StudentCareServices from '@/services/StudentCareServices';
import TaskServices from '@/services/TaskRepository';
import NoticeByDate from './NoticeByDate.vue';

export default {
  components: {
    NoticeByDate,
  },
  props: {
    updatelist: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      listNoticeTask: [],
    };
  },
  watch: {
    updatelist(val) {
      if (val === 0) {
        console.log(val);
        this.getNoticeTask();
      }
    },
  },
  async created() {
    await this.getNoticeTask();
  },
  computed: {
    tasksToday() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return this.listNoticeTask.filter((task) => {
        const taskDate = new Date(task.created_at);
        taskDate.setHours(0, 0, 0, 0);
        return taskDate.getTime() === today.getTime();
      });
    },
    tasksYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      return this.listNoticeTask.filter((task) => {
        const taskDate = new Date(task.created_at);
        taskDate.setHours(0, 0, 0, 0);
        return taskDate.getTime() === yesterday.getTime();
      });
    },
    tasksOther() {
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      today.setHours(0, 0, 0, 0);
      yesterday.setHours(0, 0, 0, 0);
      return this.listNoticeTask.filter((task) => {
        const taskDate = new Date(task.created_at);
        taskDate.setHours(0, 0, 0, 0);
        return taskDate.getTime() < yesterday.getTime();
      });
    },
  },
  methods: {
    async getNoticeTask() {
      const res = await StudentCareServices.getListNotification();
      if (res && res.data) {
        this.listNoticeTask = res.data;
      }
    },
    async redirectListTask(item) {
      if (item.type === 1 || item.type === 3) {
        const params = { ids: JSON.parse(item.task_id_list) };
        const res = await TaskServices.getListTask(params);
        if (res && res.data) {
          if (res.data.tasks.length) {
            Bus.$emit('openModalTriggerTask', res.data.tasks[0]);
          } else {
            this.$swal({
              title: 'Thất bại',
              text: 'Bạn không có quyền xem công việc này!',
            });
          }
        }
      } else {
        const params = { ids: JSON.parse(item.task_id_list).join(',') };
        const routeData = this.$router.resolve({ path: '/student-care/tutor-task', query: { typeCurriculum: 'online', ids: params.ids } });
        window.open(routeData.href, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.head-content {
  color: #2b2b2b;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.body-notice {
  max-height: 450px;
  overflow-y: auto;
}
</style>
